var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4729 13.1244L16.9729 9.867H13.8471V7.75312C13.8471 6.86212 14.2836 5.99306 15.6837 5.99306H17.1046V3.21994C17.1046 3.21994 15.8153 3 14.5823 3C12.0083 3 10.3259 4.56038 10.3259 7.38469V9.86756H7.46445V13.125H10.3259V21H13.8471V13.125L16.4729 13.1244Z",
    fill: "#051655"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/socialFacebook.26db256b3700e7f8506ab7fd07a9b4c3.svg";
export { ForwardRef as ReactComponent };